import { breakpoints, device } from "./breakpoints";
const registerURL = "https://app.ustrive.com/students";

export { device, breakpoints, registerURL };
